import type { ProviderManifest } from '../../types';

export const iflytekManifest: ProviderManifest = {
  id: 'iflytek',
  label: 'iFlyTek',
  shortLabel: 'iFlytek',
  vendor: 'iFLYTEK (Singapore endpoints)',
  capabilities: { tts: true, stt: true },
  transport: { tts: 'ws-stream', stt: 'ws-stream' },
  // TTS has no Burmese voice in the vendor voice table, so 'my' is deliberately
  // omitted — provider resolution will fall back rather than read Burmese text
  // aloud in an English voice. IST STT does accept language_name: 'my'.
  languages: {
    tts: ['en', 'bn', 'ta', 'hi', 'cn', 'ml', 'te'],
    stt: ['en', 'bn', 'my', 'ta', 'hi', 'cn', 'ml', 'te'],
  },
  notes: 'No Burmese TTS voice available. Requires IFLYTEK_APP_ID / _API_KEY / _API_SECRET.',
};
